module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-07.2c25a2b3.png";